import { render, staticRenderFns } from "./PurchaseCreate.vue?vue&type=template&id=de924360&scoped=true"
import script from "./PurchaseCreate.vue?vue&type=script&lang=js"
export * from "./PurchaseCreate.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCreate.vue?vue&type=style&index=0&id=de924360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de924360",
  null
  
)

export default component.exports